import { Stack } from '@mui/material';
import tokens from '@verifime/design-tokens';

import CameraAtEyeLevelIcon from './facecheck-camera-eye-level.svg';
import FaceVisibleIcon from './facecheck-face-visible.svg';
import GoodLightingIcon from './facecheck-good-lighting.svg';
import GuideItem, { TGuideItem } from './GuideItem';

const goodItems: TGuideItem[] = [
  {
    label: 'Good lighting',
    description: 'Ensure good lighting: avoid harsh, overly bright, or dark conditions.',
    icon: GoodLightingIcon,
  },
  {
    label: 'Camera at eye level',
    description:
      'Hold the camera at eye level, keep a neutral expression, and look directly into the camera.',
    icon: CameraAtEyeLevelIcon,
  },
  {
    label: 'Face visible',
    description:
      'Make sure your face is fully visible and push your hair back so your eyebrows can be seen clearly.',
    icon: FaceVisibleIcon,
  },
];

export default function AcceptedSection({ dataTestId }: Readonly<{ dataTestId: string }>) {
  return (
    <Stack
      direction={['column', 'row']}
      gap={tokens.spacingBase}
      data-component="accepted-section"
      data-testid={dataTestId}
    >
      {goodItems.map((item) => (
        <Stack
          key={item.label}
          direction={['row', 'column']}
          gap={tokens.spacingSm}
          alignItems="center"
          flex={1}
          data-component="accepted-item"
        >
          <GuideItem
            item={item}
            variant="full"
            dataComponent="accepted-item-icon"
            dataTestId={`${dataTestId}-${item.label.replace(/\s+/g, '-').toLowerCase()}`}
          />
        </Stack>
      ))}
    </Stack>
  );
}
